import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './Layout.css';

const Layout = ({ children }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const { user, logout } = useAuth();
    const location = useLocation();

    const menuItems = [
        { path: '/', label: 'Главная', icon: '🏠' },
        { path: '/weight', label: 'Вес', icon: '⚖️' },
        { path: '/workouts', label: 'Тренировки', icon: '💪' },
        { path: '/bad-habits', label: 'Негативные привычки', icon: '🍷' },
        { path: '/charts', label: 'Графики', icon: '📊' },
        { path: '/settings', label: 'Настройки', icon: '⚙️' }
    ];

    // Add admin menu item for admins
    if (user?.role === 'admin') {
        menuItems.push({ path: '/admin', label: 'Админ-панель', icon: '👨‍💼' });
    }

    const toggleMenu = () => setMenuOpen(!menuOpen);

    const handleLogout = () => {
        logout();
        setMenuOpen(false);
    };

    return (
        <div className="layout">
            <header className="header">
                <div className="header-content">
                    <button className="menu-btn" onClick={toggleMenu}>
                        ☰
                    </button>
                    <h1 className="app-title">Health Tracker</h1>
                    <div className="user-info">
                        <span>{user?.name || user?.email}</span>
                    </div>
                </div>
            </header>

            {menuOpen && <div className="overlay" onClick={toggleMenu}></div>}

            <nav className={`sidebar ${menuOpen ? 'open' : ''}`}>
                <ul className="menu-list">
                    {menuItems.map((item) => (
                        <li key={item.path}>
                            <Link
                                to={item.path}
                                className={`menu-item ${location.pathname === item.path ? 'active' : ''}`}
                                onClick={() => setMenuOpen(false)}
                            >
                                <span className="menu-icon">{item.icon}</span>
                                <span className="menu-label">{item.label}</span>
                            </Link>
                        </li>
                    ))}
                    <li>
                        <button className="menu-item logout-btn" onClick={handleLogout}>
                            <span className="menu-icon">🚪</span>
                            <span className="menu-label">Выход</span>
                        </button>
                    </li>
                </ul>
            </nav>

            <main className="main-content">
                {children}
            </main>
        </div>
    );
};

export default Layout;
